<div class="search-bar {{searchBarClass}}"
     [style.min-width]="minWidth"
     [class.full-screen]="isFullScreen">
  <img src="assets/icons/icons-alt/search.svg" alt="Search" width="16" height="16">
  <input type="text"
         class="form-control"
         spellcheck="false"
         [placeholder]="placeholder"
         [id]="id"
         [(ngModel)]="inputValue"
         (ngModelChange)="searchQuery.emit($event)">
</div>